// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2gQxu","loaderOuter":"PageOverlayLoader_loaderOuter__2263L"};